export const ideaBulb = '/assets/icons/idea-bulb.png'
export const googleIcon = '/assets/icons/googleIcon.png'
export const microsoftIcon = '/assets/icons/microsoftIcon.png'

export const gptIcon = '/assets/icons/gptIcon.png'
export const perplexityIcon = '/assets/icons/perplexityIcon.png'

export const docIcon = '/assets/icons/doc.png'
export const fileIcon = '/assets/icons/file.png'
export const folderIcon = '/assets/icons/folder.png'
export const htmlIcon = '/assets/icons/html.png'
export const linkIcon = '/assets/icons/link.png'
export const pdfIcon = '/assets/icons/pdf.png'
export const pictureIcon = '/assets/icons/picture.png'
export const pptIcon = '/assets/icons/ppt.png'
export const videoIcon = '/assets/icons/video.png'
export const youtubeIcon = '/assets/icons/youtube.png'
